import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface RemoveInvestigationInvolvedEmployeeCommand { investigationId: string; userId: string; }

@Injectable({ providedIn: 'root' })
export class RemoveInvestigationInvolvedEmployeeUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: RemoveInvestigationInvolvedEmployeeCommand): Observable<void> {
    return this._repository.removeInvolvedEmployee(command.investigationId, command.userId);
  }
}
